// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"88c7296f","239":"e5d3ff98","455":"7c3a4534"}[chunkId] + ".chunk.js";
};